// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"cbd43191","121":"20c5a740","163":"587eecbe","251":"05a1f6ce","283":"4f2664b8","420":"45b5c52c","460":"94787270","606":"4bf110ca","693":"c7627ce8","767":"eafafdb6","805":"ab3ed095","848":"0600239d","916":"f43c6d69"}[chunkId] + ".chunk.js";
};